/** @jsxImportSource theme-ui */
import { Col, Container } from "@bottlebooks/gatsby-design-system";
import { Fragment } from "react";
import { FragmentType, graphql, useFragment } from "~/gql";
import ContentRow from "../ContentRow";
import Representatives from "../ExhibitorPage/Representatives.next";
import ProductDetailsSection from "./ProductDetailsSection.next";

export const fragment = graphql(`
  fragment ProductSections_RegisteredProduct on RegisteredProduct {
    productId
    registration {
      ...Representatives
    }
    product {
      ...ProductDetailsSection
    }
    # ...NoteableBanner
  }
`);

/**
 * A component to contain all the product details sections.
 * It can be used to prepend or append some content in shadowed components.
 * @param {object} props
 * @param {object} props.exhibitor The exhibitor.
 * @param {object} props.product The product.
 * @param {object} props.eventId The eventId.
 * @returns
 */
export default function ProductSections({
  data,
}: {
  data: FragmentType<typeof fragment>;
}) {
  const registeredProduct = useFragment(fragment, data);
  const registration = registeredProduct.registration;
  const product = registeredProduct.product;
  return (
    <Fragment>
      <Container sx={{ width: "100%" }}>
        <ContentRow>
          <Col flex>
            <Representatives data={registration} sx={{ marginBottom: 3 }} />
          </Col>
        </ContentRow>
        <ContentRow>
          <ProductDetailsSection data={product} />
        </ContentRow>
      </Container>
      {/* <NoteableBanner product={product} /> */}
    </Fragment>
  );
}
